import { render, staticRenderFns } from "./ConceptSalesOrderForm.vue?vue&type=template&id=24402470&scoped=true&"
import script from "./ConceptSalesOrderForm.vue?vue&type=script&lang=ts&"
export * from "./ConceptSalesOrderForm.vue?vue&type=script&lang=ts&"
import style0 from "./ConceptSalesOrderForm.vue?vue&type=style&index=0&id=24402470&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24402470",
  null
  
)

export default component.exports